/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Translations_Imported_SuccessInputs */

const en_translations_imported_success = /** @type {(inputs: Translations_Imported_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} translations imported successfully`)
};

const fr_translations_imported_success = /** @type {(inputs: Translations_Imported_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} traductions importées avec succès`)
};

const de_translations_imported_success = /** @type {(inputs: Translations_Imported_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Übersetzungen erfolgreich importiert`)
};

const it_translations_imported_success = /** @type {(inputs: Translations_Imported_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} traduzioni importate con successo`)
};

const ru_translations_imported_success = /** @type {(inputs: Translations_Imported_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} переводов успешно импортировано`)
};

const es_translations_imported_success = /** @type {(inputs: Translations_Imported_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} traducciones importadas exitosamente`)
};

const zh_cn2_translations_imported_success = /** @type {(inputs: Translations_Imported_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个翻译已成功导入`)
};

const ja_translations_imported_success = /** @type {(inputs: Translations_Imported_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}件の翻訳が正常にインポートされました`)
};

const hi_translations_imported_success = /** @type {(inputs: Translations_Imported_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} अनुवाद सफलतापूर्वक आयात हो गए`)
};

const pt_pt2_translations_imported_success = /** @type {(inputs: Translations_Imported_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} traduções importadas com sucesso`)
};

/**
* | output |
* | --- |
* | "{count} translations imported successfully" |
*
* @param {Translations_Imported_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translations_imported_success = /** @type {((inputs: Translations_Imported_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translations_Imported_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translations_imported_success(inputs)
	if (locale === "de") return de_translations_imported_success(inputs)
	if (locale === "it") return it_translations_imported_success(inputs)
	if (locale === "ru") return ru_translations_imported_success(inputs)
	if (locale === "es") return es_translations_imported_success(inputs)
	if (locale === "zh-CN") return zh_cn2_translations_imported_success(inputs)
	if (locale === "ja") return ja_translations_imported_success(inputs)
	if (locale === "hi") return hi_translations_imported_success(inputs)
	if (locale === "pt-PT") return pt_pt2_translations_imported_success(inputs)
	return en_translations_imported_success(inputs)
});